import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  MenuItem,
  Divider,
  Chip,
  IconButton,
  Tooltip,
  CircularProgress,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  ListSubheader
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SearchIcon from '@mui/icons-material/Search';
import { db, auth } from '../../firebase';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit
} from 'firebase/firestore';
import { storage } from '../../firebase';
import { ref, deleteObject, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { addLog } from '../../services/logs';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import {
  watchMaterialMap,
  jewelryMaterialMap,
  jewelryTypeMap,
  goldColorMap,
  locationMap,
  statusMap,
  categoryMap,
  collectionMap,
  stoneTypeMap,
  stoneShapeMap,
  stoneCutMap,
  stonePolishMap,
  stoneSymmetryMap,
  stoneColorMap,
  stoneClarityMap,
  braceletMap,
  diamondsMap,
  colorMap,
  conditionMap,
  documentsMap,
  claspTypeMap,
  translateValue
} from '../../utils/productMappings';

// Definicja struktury marek i modeli zegarków
const WATCH_BRANDS_MODELS_BRACELETS = {
  "Rolex": {
    "Oyster Perpetual": {
      "diameters": [28, 31, 34, 36, 41],
      "bracelets": ["Oyster"]
    },
    "Datejust": {
      "diameters": [31, 36, 41],
      "bracelets": ["Oyster", "Jubilee"]
    },
    "Day-Date": {
      "diameters": [36, 40],
      "bracelets": ["President"]
    },
    "Submariner": {
      "diameters": [41],
      "bracelets": ["Oyster"]
    },
    "GMT-Master II": {
      "diameters": [40],
      "bracelets": ["Oyster", "Jubilee"]
    },
    "Explorer": {
      "diameters": [36, 39],
      "bracelets": ["Oyster"]
    },
    "Yacht-Master": {
      "diameters": [37, 40, 42],
      "bracelets": ["Oyster", "Oysterflex"]
    }
  },
  "Chopard": {
    "Happy Sport": {
      "diameters": [30, 36, 40],
      "bracelets": ["Bransoleta stalowa", "Pasek skórzany"]
    },
    "Mille Miglia": {
      "diameters": [39, 42, 44],
      "bracelets": ["Pasek gumowy"]
    },
    "L.U.C": {
      "diameters": [39, 40, 42],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Alpine Eagle": {
      "diameters": [36, 41, 44],
      "bracelets": ["Bransoleta zintegrowana"]
    },
    "Happy Diamonds": {
      "diameters": [30, 32, 36],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Impériale": {
      "diameters": [29, 36, 40],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    }
  },
  "Cartier": {
    "Tank Louis": {
      "diameters": [25, 29, 33],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Tank Must": {
      "diameters": [29, 34],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Tank Française": {
      "diameters": [25, 30, 37],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Tank Américaine": {
      "diameters": [19, 22, 27],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Tank Anglaise": {
      "diameters": [26, 30, 39],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Tank MC": {
      "diameters": [34, 39, 44],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Tank Solo": {
      "diameters": [24, 31, 35],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Santos de Cartier": {
      "diameters": [35, 40, 48],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Santos Demoiselle": {
      "diameters": [20, 26],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Santos-Dumont": {
      "diameters": [27, 31, 38, 43],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Panthère de Cartier": {
      "diameters": [22, 27, 30],
      "bracelets": ["Bransoleta metalowa"]
    },
    "Ballon Bleu de Cartier": {
      "diameters": [28, 33, 36, 40, 42],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Pasha de Cartier": {
      "diameters": [35, 41, 42],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Baignoire": {
      "diameters": [24, 31, 35],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Ronde de Cartier": {
      "diameters": [29, 36, 40, 42],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Cartier Libre": {
      "diameters": [30, 35, 40],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    }
  },
  "Audemars Piguet": {
    "Royal Oak": {
      "diameters": [33, 34, 37, 39, 41],
      "bracelets": ["Bransoleta zintegrowana"]
    },
    "Royal Oak Offshore": {
      "diameters": [42, 44],
      "bracelets": ["Bransoleta metalowa", "Pasek gumowy", "Pasek skórzany"]
    },
    "Code 11.59": {
      "diameters": [38, 41],
      "bracelets": ["Pasek skórzany"]
    }
  },
  "Patek Philippe": {
    "Nautilus": {
      "diameters": [35, 40, 42],
      "bracelets": ["Bransoleta zintegrowana"]
    },
    "Aquanaut": {
      "diameters": [36, 39, 42],
      "bracelets": ["Pasek kompozytowy"]
    },
    "Calatrava": {
      "diameters": [36, 37, 38, 39],
      "bracelets": ["Pasek skórzany"]
    },
    "Gondolo": {
      "diameters": [30, 32, 36, 38, 40],
      "bracelets": ["Pasek skórzany", "Bransoleta metalowa"]
    }
  }
};

const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [editedProduct, setEditedProduct] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openReportSaleDialog, setOpenReportSaleDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });
  const [selectedImages, setSelectedImages] = useState([]);
  const [saleData, setSaleData] = useState({
    location: '',
    company: 'MM_GOLD',
    payment_method: 'cash',
    sale_date: format(new Date(), 'yyyy-MM-dd'),
    amount: '',
    status: 'pending', // pending, approved, rejected
    client_id: '', // ID wybranego klienta
    client_name: '' // Nazwa klienta (tylko do wyświetlenia)
  });
  
  // Stan dla klientów
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [loadingClients, setLoadingClients] = useState(false);
  const [showNewClientForm, setShowNewClientForm] = useState(false);
  const [newClientData, setNewClientData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: '',
    notes: ''
  });
  
  // Stan dla raportów sprzedaży
  const [salesReports, setSalesReports] = useState([]);
  const [loadingReports, setLoadingReports] = useState(false);
  
  const { currentUser, isAdmin, isMarketing } = useContext(AuthContext);
  console.log('Current user:', currentUser);
  console.log('Custom claims:', currentUser?.customClaims);
  console.log('Is admin:', isAdmin);
  console.log('Is marketing:', isMarketing);

  const handleToggleEditMode = () => {
    if (!editMode) {
      // Włączamy tryb edycji i kopiujemy dane produktu do stanu edycji
      setEditedProduct({...product});
      setEditMode(true);
    } else {
      // Wyłączamy tryb edycji bez zapisywania
      setEditMode(false);
      setEditedProduct(null);
      setSelectedImages([]);
    }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedProduct(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleNumberInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value === '' ? '' : parseFloat(value);
    setEditedProduct(prev => ({
      ...prev,
      [name]: newValue
    }));
  };
  
  const handleImageSelect = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setSelectedImages(prev => [...prev, ...newFiles]);
    }
  };
  
  const handleRemoveSelectedImage = (index) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
  };
  
  const handleRemoveExistingImage = (index) => {
    setEditedProduct(prev => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };
  
  const handleSaveChanges = async () => {
    try {
      if (!currentUser) {
        throw new Error('Musisz być zalogowany aby zapisać zmiany');
      }
      
      if (!isAdmin && !isMarketing) {
        throw new Error('Brak uprawnień do edycji produktu');
      }
      
      setIsSubmitting(true);
      
      // Przygotowanie danych do aktualizacji
      const dataToUpdate = {
        ...editedProduct,
        updated_at: new Date(),
        updated_by: {
          uid: currentUser.uid,
          email: currentUser.email,
          displayName: currentUser.displayName || ''
        }
      };
      
      // Obsługa niestandardowego koloru tarczy
      if (editedProduct.dial_color === 'other') {
        // Jeśli nie ma display_dial_color, ustawiamy domyślną wartość
        if (!editedProduct.display_dial_color) {
          dataToUpdate.display_dial_color = 'Niestandardowy';
        }
        // W przeciwnym razie display_dial_color jest już ustawione w editedProduct
      } else {
        // Jeśli kolor tarczy nie jest 'other', usuwamy display_dial_color
        dataToUpdate.display_dial_color = editedProduct.dial_color;
      }
      
      // Referencja do dokumentu produktu
      const productRef = doc(db, 'products', id);
      
      // Dodajemy nowe zdjęcia jeśli istnieją
      if (selectedImages.length > 0) {
        const newImageUrls = [];
        for (const image of selectedImages) {
          const storageRef = ref(storage, `products/${id}/${image.name}`);
          await uploadBytes(storageRef, image);
          const url = await getDownloadURL(storageRef);
          newImageUrls.push(url);
        }
        
        // Dodajemy nowe zdjęcia do istniejących
        dataToUpdate.images = [...(dataToUpdate.images || []), ...newImageUrls];
      }
      
      // Aktualizujemy dokument w Firestore
      await updateDoc(productRef, dataToUpdate);
      
      // Dodajemy wpis do logów
      await addLog({
        action: 'product_update',
        entity_type: 'product',
        entity_id: id,
        user_id: currentUser.uid,
        details: dataToUpdate,
        location: dataToUpdate.location
      });
      
      // Odświeżamy dane produktu
      setProduct(dataToUpdate);
      setEditMode(false);
      setEditedProduct(null);
      setSelectedImages([]);
      
      // Powiadomienie
      setSnackbar({
        open: true,
        message: 'Produkt został zaktualizowany pomyślnie',
        severity: 'success'
      });
      
    } catch (error) {
      console.error('Error updating product:', error);
      setSnackbar({
        open: true,
        message: `Błąd podczas aktualizacji: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const productRef = doc(db, 'products', id);
        const productSnap = await getDoc(productRef);

        if (!productSnap.exists()) {
          throw new Error('Produkt nie istnieje');
        }

        const data = {
          id: productSnap.id,
          ...productSnap.data()
        };
        console.log('Dane produktu:', data);
        setProduct(data);
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    };

    fetchProduct();
  }, [id]);

  useEffect(() => {
    if (isAdmin) {
      fetchSalesReports();
    }
    fetchClients();
  }, [id, isAdmin]);
  
  // Funkcja do pobierania klientów
  const fetchClients = async () => {
    try {
      setLoadingClients(true);
      const clientsRef = collection(db, 'clients');
      // Dodajemy sortowanie po dacie utworzenia, aby najnowsi klienci byli na górze
      const clientsQuery = query(clientsRef, orderBy('created_at', 'desc'));
      const clientsSnapshot = await getDocs(clientsQuery);
      const clientsList = clientsSnapshot.docs.map(doc => {
        const data = doc.data();
        // Obsługa różnych formatów danych klienta
        const firstName = data.firstName || (data.name ? data.name.split(' ')[0] : '');
        const lastName = data.lastName || (data.name && data.name.split(' ').length > 1 ? 
          data.name.split(' ').slice(1).join(' ') : '');
        
        return {
          id: doc.id,
          ...data,
          firstName: firstName,
          lastName: lastName,
          displayName: data.name || `${firstName} ${lastName}`.trim()
        };
      });
      console.log('Pobrani klienci:', clientsList);
      setClients(clientsList);
      setFilteredClients(clientsList);
    } catch (error) {
      console.error('Błąd podczas pobierania klientów:', error);
      setSnackbar({
        open: true,
        message: `Błąd podczas pobierania klientów: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setLoadingClients(false);
    }
  };
  
  // Funkcja do filtrowania klientów
  const filterClients = (searchTerm) => {
    setClientSearchTerm(searchTerm);
    if (!searchTerm.trim()) {
      setFilteredClients(clients);
      return;
    }
    
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const filtered = clients.filter(client => {
      const fullName = (client.name || `${client.firstName || ''} ${client.lastName || ''}`).toLowerCase();
      const phone = (client.phone || '').toLowerCase();
      const email = (client.email || '').toLowerCase();
      
      return fullName.includes(lowerCaseSearchTerm) || 
             phone.includes(lowerCaseSearchTerm) || 
             email.includes(lowerCaseSearchTerm);
    });
    
    setFilteredClients(filtered);
  };

  // Funkcja pobierająca raporty sprzedaży do zatwierdzenia (tylko dla administratorów)
  const fetchSalesReports = async () => {
    if (!isAdmin) return;
    
    try {
      setLoadingReports(true);
      const reportsRef = collection(db, 'sales_reports');
      const reportsQuery = query(reportsRef, where('status', '==', 'pending'));
      const reportsSnapshot = await getDocs(reportsQuery);
      
      const reportsList = reportsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        reported_at: doc.data().reported_at?.toDate() || new Date(),
        transactionDate: doc.data().transactionDate?.toDate() || new Date()
      }));
      
      setSalesReports(reportsList);
    } catch (error) {
      console.error('Błąd podczas pobierania raportów sprzedaży:', error);
    } finally {
      setLoadingReports(false);
    }
  };

  // Funkcja do zatwierdzania raportu sprzedaży
  const handleApproveReport = async (reportId) => {
    try {
      // Pobierz dane raportu
      const reportRef = doc(db, 'sales_reports', reportId);
      const reportSnap = await getDoc(reportRef);
      
      if (!reportSnap.exists()) {
        throw new Error('Raport sprzedaży nie istnieje');
      }
      
      const reportData = reportSnap.data();
      
      // Przenieś dane do kolekcji sales
      const salesRef = collection(db, 'sales');
      await addDoc(salesRef, {
        ...reportData,
        status: 'approved',
        approved_at: new Date(),
        approved_by: {
          uid: currentUser.uid,
          email: currentUser.email,
          name: `${currentUser.firstName} ${currentUser.lastName}`
        }
      });
      
      // Aktualizuj status raportu
      await updateDoc(reportRef, {
        status: 'approved',
        approved_at: new Date(),
        approved_by: {
          uid: currentUser.uid,
          email: currentUser.email,
          name: `${currentUser.firstName} ${currentUser.lastName}`
        }
      });
      
      // Aktualizuj status produktu na sold_pending (oczekuje na zatwierdzenie)
      // Aktualizuj status produktu
      if (reportData.product_id) {
        const productRef = doc(db, 'products', reportData.product_id);
        await updateDoc(productRef, {
          status: 'sold',
          sold_at: new Date(),
          sold_by: reportData.employeeId,
          sold_for: reportData.amount
        });
      }
      
      // Odśwież listę raportów
      fetchSalesReports();
      
      setSnackbar({
        open: true,
        message: 'Raport sprzedaży został zatwierdzony',
        severity: 'success'
      });
    } catch (error) {
      console.error('Błąd podczas zatwierdzania raportu:', error);
      setSnackbar({
        open: true,
        message: `Błąd podczas zatwierdzania raportu: ${error.message}`,
        severity: 'error'
      });
    }
  };
  
  // Funkcja do odrzucania raportu sprzedaży
  const handleRejectReport = async (reportId) => {
    try {
      // Pobierz dane raportu
      const reportRef = doc(db, 'sales_reports', reportId);
      const reportSnap = await getDoc(reportRef);
      
      if (!reportSnap.exists()) {
        throw new Error('Raport sprzedaży nie istnieje');
      }
      
      const reportData = reportSnap.data();
      
      // Aktualizuj status raportu
      await updateDoc(reportRef, {
        status: 'rejected',
        rejected_at: new Date(),
        rejected_by: {
          uid: currentUser.uid,
          email: currentUser.email,
          name: `${currentUser.firstName} ${currentUser.lastName}`
        }
      });
      
      // Aktualizuj status produktu (przywróć do dostępnego)
      if (reportData.product_id) {
        const productRef = doc(db, 'products', reportData.product_id);
        await updateDoc(productRef, {
          status: 'available',
          sale_reported_at: null,
          sale_reported_by: null,
          sale_report_id: null,
          sale_data: null
        });
      }
      
      // Odśwież listę raportów
      fetchSalesReports();
      
      setSnackbar({
        open: true,
        message: 'Raport sprzedaży został odrzucony',
        severity: 'success'
      });
    } catch (error) {
      console.error('Błąd podczas odrzucania raportu:', error);
      setSnackbar({
        open: true,
        message: `Błąd podczas odrzucania raportu: ${error.message}`,
        severity: 'error'
      });
    }
  };

  const handlePrevImage = () => {
    if (product?.images?.length > 0) {
      setSelectedImageIndex((prev) => 
        prev === 0 ? product.images.length - 1 : prev - 1
      );
    }
  };

  const handleNextImage = () => {
    if (product?.images?.length > 0) {
      setSelectedImageIndex((prev) => 
        prev === product.images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const handleDelete = async () => {
    try {
      if (!currentUser) {
        throw new Error('Musisz być zalogowany');
      }

      if (!isAdmin && !isMarketing) {
        throw new Error('Brak uprawnień do usunięcia produktu');
      }

      // Zapisz dane produktu przed usunięciem
      const productData = {
        ...product,
        deletedAt: new Date().toISOString(),
        deletedBy: {
          uid: currentUser.uid,
          email: currentUser.email
        }
      };

      // Wywołaj funkcję logującą
      const token = await auth.currentUser.getIdToken();
      await fetch('https://logproductdeletion-hfdpmvqymq-uc.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          productId: id,
          productData
        })
      });

      // Usuwanie zdjęć z Firebase Storage
      if (product.images && product.images.length > 0) {
        for (const imageUrl of product.images) {
          try {
            const decodedUrl = decodeURIComponent(imageUrl);
            const filePathMatch = decodedUrl.match(/o\/(.+?)\?/);
            if (filePathMatch && filePathMatch[1]) {
              const filePath = filePathMatch[1];
              const imageRef = ref(storage, filePath);
              await deleteObject(imageRef);
            }
          } catch (error) {
            console.error('Error deleting image:', error);
          }
        }
      }

      console.log('Rozpoczynam logowanie usunięcia produktu');
      
      try {
        // Bezpośrednie logowanie do kolekcji logs
        await addLog({
          action: 'product_delete',
          entity_type: 'product',
          entity_id: id,
          user_id: currentUser.uid,
          details: productData,
          location: product.location || ''
        });
        console.log('Usunięcie produktu zostało zalogowane');
      } catch (logError) {
        console.error('Błąd podczas logowania usunięcia:', logError);
      }
      
      // Usuwanie dokumentu produktu
      console.log('Usuwam dokument produktu:', id);
      await deleteDoc(doc(db, 'products', id));
      console.log('Dokument produktu został usunięty');
      
      navigate('/products');
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };

  const formatPrice = (price) => {
    if (typeof price !== 'number' || isNaN(price)) {
      return 'Cena nieustalona';
    }
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN'
    }).format(price);
  };

  // Funkcja do tworzenia nowego klienta
  const handleCreateClient = async () => {
    try {
      if (!newClientData.firstName || !newClientData.lastName) {
        throw new Error('Imię i nazwisko są wymagane');
      }

      // Przygotuj dane klienta w formacie zgodnym z bazą danych
      const clientData = {
        ...newClientData,
        name: `${newClientData.firstName} ${newClientData.lastName}`.trim(), // Dodaj pole name dla kompatybilności
        created_at: new Date(),
        updated_at: new Date(),
        createdAt: new Date(), // Dodaj pole createdAt dla kompatybilności z CRM
        assignedTo: currentUser.uid, // Przypisz klienta do aktualnie zalogowanego użytkownika
        lastContactDate: new Date(), // Ustaw datę ostatniego kontaktu na teraz
        created_by: {
          uid: currentUser.uid,
          name: `${currentUser.firstName} ${currentUser.lastName}`,
          email: currentUser.email
        }
      };

      const clientsRef = collection(db, 'clients');
      const docRef = await addDoc(clientsRef, clientData);
      
      // Pobierz świeżą listę klientów po dodaniu nowego
      await fetchClients();
      
      // Ustaw nowego klienta jako wybranego
      setSaleData({
        ...saleData,
        client_id: docRef.id,
        client_name: clientData.name
      });
      
      // Ustaw filtr wyszukiwania na nowo dodanego klienta, aby był widoczny
      setClientSearchTerm(clientData.name);
      
      // Resetuj formularz nowego klienta
      setNewClientData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        postalCode: '',
        notes: ''
      });
      setShowNewClientForm(false);
      
      setSnackbar({
        open: true,
        message: 'Klient został dodany pomyślnie',
        severity: 'success'
      });
    } catch (error) {
      console.error('Błąd podczas tworzenia klienta:', error);
      setSnackbar({
        open: true,
        message: `Błąd podczas tworzenia klienta: ${error.message}`,
        severity: 'error'
      });
    }
  };

  const handleSaleDataChange = (e) => {
    const { name, value } = e.target;
    setSaleData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Jeśli zmieniono klienta, zaktualizuj również client_name
    if (name === 'client_id' && value) {
      const selectedClient = clients.find(client => client.id === value);
      if (selectedClient) {
        const clientName = selectedClient.name || 
          `${selectedClient.firstName || ''} ${selectedClient.lastName || ''}`.trim();
        setSaleData(prev => ({
          ...prev,
          client_name: clientName
        }));
      }
    }
  };

  const handleReportSale = async () => {
    try {
      if (!currentUser) {
        throw new Error('Musisz być zalogowany');
      }
      if (!saleData.amount || parseFloat(saleData.amount) <= 0) {
        throw new Error('Proszę podać poprawną kwotę sprzedaży');
      }
      if (!saleData.client_id) {
        throw new Error('Proszę wybrać klienta');
      }

      setIsSubmitting(true);
      
      // Pobierz aktualne dane klienta z Firestore
      const clientRef = doc(db, 'clients', saleData.client_id);
      const clientSnap = await getDoc(clientRef);
      let clientData = {};
      
      if (clientSnap.exists()) {
        clientData = clientSnap.data();
      } else {
        throw new Error('Nie znaleziono wybranego klienta');
      }
      
      console.log('Dane klienta do raportu sprzedaży:', clientData);
      
      // Użyj pola name jeśli istnieje, w przeciwnym razie użyj firstName i lastName
      const clientName = clientData.name || 
        `${clientData.firstName || ''} ${clientData.lastName || ''}`.trim();

      // Upewnij się, że mamy poprawną datę sprzedaży
      let saleDate;
      try {
        // Spróbuj utworzyć datę z podanej wartości
        saleDate = saleData.sale_date ? new Date(saleData.sale_date) : new Date();
        // Sprawdź, czy data jest poprawna
        if (isNaN(saleDate.getTime())) {
          console.warn('Nieprawidłowa data sprzedaży, używam bieżącej daty');
          saleDate = new Date();
        }
      } catch (error) {
        console.warn('Błąd podczas przetwarzania daty sprzedaży:', error);
        saleDate = new Date();
      }
      
      // Przygotuj dane sprzedaży - używamy tylko jednej kolekcji 'sales'
      const salesData = {
        productId: id,
        productData: {
          brand: product.brand || '',
          model: product.model || '',
          reference: product.reference || '',
          material: product.material || '',
          price: product.price || 0,
          images: product.images || [],
          location: product.location || ''
        },
        clientId: saleData.client_id,
        clientName: clientName,
        location: saleData.location || '',
        company: saleData.company || '',
        payment_method: saleData.payment_method || '',
        totalAmount: parseFloat(saleData.amount) || 0,
        employeeId: currentUser.uid,
        employeeName: currentUser.displayName || `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim(),
        transactionDate: saleDate,
        createdAt: new Date(),
        lastUpdate: new Date(),
        paymentStatus: saleData.paymentStatus || 'pending',
        deliveryStatus: saleData.deliveryStatus || 'pending',
        source: 'product_report',
        notes: saleData.notes || ''
      };

      console.log('Przygotowane dane sprzedaży:', salesData);
      
      try {
        // Dodaj wpis do kolekcji sales
        const salesRef = collection(db, 'sales');
        const saleDocRef = await addDoc(salesRef, salesData);
        console.log('Wpis sprzedaży dodany z ID:', saleDocRef.id);
        
        // Zaktualizuj status produktu
        const productRef = doc(db, 'products', id);
        await updateDoc(productRef, {
          status: 'sold_pending',
          sale_id: saleDocRef.id,
          updated_at: new Date()
        });
        console.log('Status produktu zaktualizowany');
        
        // Zaktualizuj dane klienta - totalSpent i lastPurchaseDate
        const currentTotalSpent = parseFloat(clientData.totalSpent) || 0;
        const newTotalSpent = currentTotalSpent + parseFloat(saleData.amount);
        
        await updateDoc(clientRef, {
          lastPurchaseDate: saleDate,
          totalSpent: newTotalSpent,
          updated_at: new Date(),
          updated_by: {
            uid: currentUser.uid,
            email: currentUser.email,
            displayName: currentUser.displayName || ''
          }
        });
        console.log('Dane klienta zaktualizowane');
      } catch (firestoreError) {
        console.error('Błąd Firestore podczas zapisywania danych:', firestoreError);
        throw new Error(`Błąd podczas zapisywania danych: ${firestoreError.message}`);
      }

      // Opcjonalnie: dodaj log aktywności
      if (currentUser && currentUser.uid) {
        const activityLogRef = collection(db, 'activity_logs');
        await addDoc(activityLogRef, {
          user_id: currentUser.uid,
          user_name: `${currentUser.firstName} ${currentUser.lastName}`,
          action: 'report_sale',
          target_type: 'product',
          target_id: id,
          details: {
            product_brand: product.brand,
            product_model: product.model,
            amount: saleData.amount,
            client_name: clientName
          },
          timestamp: new Date()
        });
      }

      setSnackbar({
        open: true,
        message: 'Sprzedaż została zgłoszona pomyślnie',
        severity: 'success'
      });

      setOpenReportSaleDialog(false);
      
      // Odświeżenie strony po zgłoszeniu sprzedaży
      window.location.reload();
      
    } catch (error) {
      console.error('Error reporting sale:', error);
      setSnackbar({
        open: true,
        message: `Błąd podczas zgłaszania sprzedaży: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!product) {
    return (
      <Container>
        <Typography>Ładowanie...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          variant="outlined"
          onClick={() => navigate('/products')}
          sx={{ mb: 2 }}
        >
          Powrót do listy
        </Button>

        {(isAdmin || isMarketing) && (
          <Box>
            {!editMode ? (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleToggleEditMode}
                  sx={{ mr: 2 }}
                >
                  Edytuj produkt
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => setOpenDeleteDialog(true)}
                  sx={{ mr: 2 }}
                >
                  Usuń produkt
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleSaveChanges}
                  disabled={isSubmitting}
                  sx={{ mr: 2 }}
                >
                  {isSubmitting ? 'Zapisywanie...' : 'Zapisz zmiany'}
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleToggleEditMode}
                  disabled={isSubmitting}
                >
                  Anuluj edycję
                </Button>
              </>
            )}
          </Box>
        )}
        
        {/* Przycisk zgłaszania sprzedaży dla wszystkich użytkowników - tylko gdy produkt nie ma jeszcze zgłoszonej sprzedaży */}
        {!editMode && currentUser && product?.status !== 'sale_reported' && (
          <Button
            variant="outlined"
            color="success"
            startIcon={<LocalOfferIcon />}
            onClick={() => {
              // Automatycznie wypełnij dane sprzedaży na podstawie danych produktu
              setSaleData({
                ...saleData,
                amount: product.price || '',
                location: product.location || '',
                sale_date: new Date().toISOString().split('T')[0]
              });
              setOpenReportSaleDialog(true);
            }}
          >
            Zgłoś sprzedaż
          </Button>
        )}
        
        {/* Informacja o już zgłoszonej sprzedaży */}
        {!editMode && currentUser && product?.status === 'sale_reported' && (
          <Alert severity="info" sx={{ mt: 2, mb: 2 }}>
            Ten produkt ma już zgłoszoną sprzedaż oczekującą na zatwierdzenie.
          </Alert>
        )}
      </Box>

      <Paper elevation={3} sx={{ p: 3 }}>
        <Grid container spacing={4}>
          {/* Zdjęcia */}
          <Grid item xs={12} md={6}>
            <Box sx={{ position: 'relative', mb: 2 }}>
              <img
                src={!editMode
                  ? (product.images?.[selectedImageIndex]
                    ? `${product.images[selectedImageIndex]}?alt=media`
                    : 'https://via.placeholder.com/600x600')
                  : (editedProduct.images?.[selectedImageIndex]
                    ? `${editedProduct.images[selectedImageIndex]}?alt=media`
                    : 'https://via.placeholder.com/600x600')
                }
                alt={`${product?.brand || ''} ${product?.model || ''}`}
                style={{
                  width: '100%',
                  height: '400px',
                  objectFit: 'contain',
                  background: '#000000'
                }}
              />
              {!editMode && product.images && product.images.length > 1 && (
                <>
                  <IconButton
                    onClick={handlePrevImage}
                    sx={{
                      position: 'absolute',
                      left: 8,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      bgcolor: 'rgba(0, 0, 0, 0.5)',
                      color: 'white',
                      '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                      },
                    }}
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                  <IconButton
                    onClick={handleNextImage}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      bgcolor: 'rgba(0, 0, 0, 0.5)',
                      color: 'white',
                      '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                      },
                    }}
                  >
                    <ChevronRightIcon />
                  </IconButton>
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 16,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      gap: 1,
                      bgcolor: 'rgba(0, 0, 0, 0.5)',
                      padding: '4px 8px',
                      borderRadius: '12px',
                    }}
                  >
                    {product.images.map((_, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          bgcolor: index === selectedImageIndex ? 'white' : 'rgba(255, 255, 255, 0.5)',
                          cursor: 'pointer',
                        }}
                        onClick={() => setSelectedImageIndex(index)}
                      />
                    ))}
                  </Box>
                </>
              )}
              {editMode && editedProduct.images && editedProduct.images.length > 1 && (
                <>
                  <IconButton
                    onClick={handlePrevImage}
                    sx={{
                      position: 'absolute',
                      left: 8,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      bgcolor: 'rgba(0, 0, 0, 0.5)',
                      color: 'white',
                      '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                      },
                    }}
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                  <IconButton
                    onClick={handleNextImage}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      bgcolor: 'rgba(0, 0, 0, 0.5)',
                      color: 'white',
                      '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                      },
                    }}
                  >
                    <ChevronRightIcon />
                  </IconButton>
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 16,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      gap: 1,
                      bgcolor: 'rgba(0, 0, 0, 0.5)',
                      padding: '4px 8px',
                      borderRadius: '12px',
                    }}
                  >
                    {editedProduct.images.map((_, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          bgcolor: index === selectedImageIndex ? 'white' : 'rgba(255, 255, 255, 0.5)',
                          cursor: 'pointer',
                        }}
                        onClick={() => setSelectedImageIndex(index)}
                      />
                    ))}
                  </Box>
                </>
              )}
            </Box>

            {/* Miniatury zdjęć w trybie podglądu */}
            {!editMode && (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2, mt: 2 }}>
                {product.images && product.images.map((image, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 80,
                      height: 80,
                      border: index === selectedImageIndex ? '2px solid #1976d2' : '2px solid transparent',
                      cursor: 'pointer',
                    }}
                    onClick={() => setSelectedImageIndex(index)}
                  >
                    <img
                      src={`${image}?alt=media`}
                      alt={`${product?.brand || ''} ${product?.model || ''} - thumbnail ${index + 1}`}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        background: '#000000'
                      }}
                    />
                  </Box>
                ))}
              </Box>
            )}
            
            {/* Zarządzanie zdjęciami w trybie edycji */}
            {editMode && (
              <>
                <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                  Zarządzanie zdjęciami
                </Typography>
                
                {/* Istniejące zdjęcia */}
                {editedProduct.images && editedProduct.images.length > 0 && (
                  <Box>
                    <Typography variant="subtitle2" gutterBottom>
                      Istniejące zdjęcia:
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                      {editedProduct.images.map((image, index) => (
                        <Box
                          key={index}
                          sx={{
                            width: 80,
                            height: 80,
                            position: 'relative',
                            border: index === selectedImageIndex ? '2px solid #1976d2' : '2px solid transparent',
                          }}
                        >
                          <img
                            src={`${image}?alt=media`}
                            alt={`Thumbnail ${index + 1}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                              cursor: 'pointer',
                              background: '#000000'
                            }}
                            onClick={() => setSelectedImageIndex(index)}
                          />
                          <IconButton
                            size="small"
                            sx={{
                              position: 'absolute',
                              top: -8,
                              right: -8,
                              bgcolor: 'error.main',
                              color: 'white',
                              width: 20,
                              height: 20,
                              '&:hover': { bgcolor: 'error.dark' }
                            }}
                            onClick={() => handleRemoveExistingImage(index)}
                          >
                            <CloseIcon style={{ fontSize: 14 }} />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
                
                {/* Nowe zdjęcia */}
                {selectedImages.length > 0 && (
                  <Box>
                    <Typography variant="subtitle2" gutterBottom>
                      Nowe zdjęcia do dodania:
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                      {selectedImages.map((file, index) => (
                        <Box
                          key={index}
                          sx={{
                            width: 80,
                            height: 80,
                            position: 'relative',
                            border: '1px dashed gray'
                          }}
                        >
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`${index + 1}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                              background: '#000000'
                            }}
                          />
                          <IconButton
                            size="small"
                            sx={{
                              position: 'absolute',
                              top: -8,
                              right: -8,
                              bgcolor: 'error.main',
                              color: 'white',
                              width: 20,
                              height: 20,
                              '&:hover': { bgcolor: 'error.dark' }
                            }}
                            onClick={() => handleRemoveSelectedImage(index)}
                          >
                            <CloseIcon style={{ fontSize: 14 }} />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
                
                {/* Przycisk dodawania zdjęć */}
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<AddAPhotoIcon />}
                  sx={{ mt: 1 }}
                >
                  Dodaj zdjęcia
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    multiple
                    onChange={handleImageSelect}
                  />
                </Button>
              </>
            )}
                <>
                  {(product?.category === 'watch' || (editMode && editedProduct?.category === 'watch')) && (
                    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                      {!editMode ? (
                        // Wyświetlanie marki i modelu w trybie normalnym
                        <>
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Marka
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {product?.brand || '-'}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Model
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {product?.model === 'other' && product?.custom_model 
                                ? product.custom_model 
                                : product?.model || '-'}
                            </Typography>
                          </Grid>
                        </>
                      ) : (
                        // Edycja marki i modelu w trybie edycji
                        <>
                          <FormControl fullWidth>
                            <InputLabel>Marka</InputLabel>
                            <Select
                              name="brand"
                              value={editedProduct?.brand || ''}
                              onChange={handleInputChange}
                              label="Marka"
                            >
                              {Object.keys(WATCH_BRANDS_MODELS_BRACELETS || {}).map((brand) => (
                                <MenuItem key={brand} value={brand}>{brand}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          
                          <FormControl fullWidth>
                            <InputLabel>Model</InputLabel>
                            <Select
                              name="model"
                              value={editedProduct?.model || ''}
                              onChange={handleInputChange}
                              label="Model"
                            >
                              {editedProduct?.brand && 
                                Object.keys(WATCH_BRANDS_MODELS_BRACELETS[editedProduct?.brand] || {}).map((model) => (
                                  <MenuItem key={model} value={model}>{model}</MenuItem>
                                ))
                              }
                              <MenuItem value="other">Inny</MenuItem>
                            </Select>
                          </FormControl>
                          {editedProduct?.model === 'other' && (
                            <TextField
                              fullWidth
                              name="custom_model"
                              label="Własny model"
                              value={editedProduct?.custom_model || ''}
                              onChange={handleInputChange}
                              margin="normal"
                              variant="outlined"
                            />
                          )}
                        </>
                      )}
                    </Box>
                  )}
                  
                  {product?.category === 'jewelry' && (
                    <TextField
                      label="Nazwa produktu"
                      fullWidth
                      margin="normal"
                      name="name"
                      value={editedProduct.name || ''}
                      onChange={handleInputChange}
                      sx={{ mb: 2 }}
                    />
                  )}
                  
                  {!editMode ? (
                    // Wyświetlanie ceny i statusu w trybie normalnym
                    <Box sx={{ mb: 2 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="text.secondary">
                            Cena
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {formatPrice(product?.price)}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="text.secondary">
                            Status
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {translateValue(product?.status, statusMap)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : (
                    // Edycja ceny i statusu w trybie edycji
                    <>
                      <TextField
                        fullWidth
                        label="Cena"
                        type="number"
                        name="price"
                        value={editedProduct?.price || ''}
                        onChange={handleNumberInputChange}
                        InputProps={{
                          startAdornment: <Box component="span" sx={{ mr: 1 }}>PLN</Box>,
                        }}
                        sx={{ mb: 2 }}
                      />
                      
                      <FormControl fullWidth margin="normal" sx={{ mb: 2 }}>
                        <InputLabel>Status</InputLabel>
                        <Select
                          name="status"
                          value={editedProduct?.status || 'available'}
                          onChange={handleInputChange}
                          label="Status"
                        >
                          {Object.entries(statusMap).map(([key, value]) => (
                            <MenuItem key={key} value={key}>{value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </>
                  )}
                </>
              

            {/* Sekcje z detalami */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Informacje podstawowe */}
              <Paper sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom color="primary">
                  Informacje podstawowe
                </Typography>
                <Grid container spacing={2}>
                  {/* ID */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                      ID
                    </Typography>
                    {!editMode ? (
                      <Typography variant="body1" gutterBottom>
                        {product.sku}
                      </Typography>
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        name="sku"
                        value={editedProduct.sku || ''}
                        onChange={handleInputChange}
                        sx={{ mt: 1 }}
                      />
                    )}
                  </Grid>
                  
                  {/* Kategoria produktu */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Kategoria produktu
                    </Typography>
                    {!editMode ? (
                      <Typography variant="body1" gutterBottom>
                        {translateValue(product.category, categoryMap)}
                      </Typography>
                    ) : (
                      <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                        <Select
                          name="category"
                          value={editedProduct.category || ''}
                          onChange={handleInputChange}
                          disabled={true} // Nie pozwalamy zmieniać kategorii
                        >
                          {Object.entries(categoryMap).map(([key, value]) => (
                            <MenuItem key={key} value={key}>{value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  
                  {/* Kolekcja */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Kolekcja
                    </Typography>
                    {!editMode ? (
                      <Typography variant="body1" gutterBottom>
                        {translateValue(product.collection, collectionMap)}
                      </Typography>
                    ) : (
                      <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                        <Select
                          name="collection"
                          value={editedProduct.collection || 'standard'}
                          onChange={handleInputChange}
                        >
                          {Object.entries(collectionMap).map(([key, value]) => (
                            <MenuItem key={key} value={key}>{value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  
                  {/* Lokalizacja */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Lokalizacja
                    </Typography>
                    {!editMode ? (
                      <Typography variant="body1" gutterBottom>
                        {translateValue(product.location, locationMap)}
                      </Typography>
                    ) : (
                      <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                        <Select
                          name="location"
                          value={editedProduct.location || ''}
                          onChange={handleInputChange}
                        >
                          {Object.entries(locationMap).map(([key, value]) => (
                            <MenuItem key={key} value={key}>{value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  
                  {product?.material && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Materiał
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        {translateValue(product.material, product.category === 'watch' ? watchMaterialMap : jewelryMaterialMap)}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Paper>

              {/* Pola dla zegarków */}
              {product.category === 'watch' && (
                <Paper sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom color="primary">
                    Szczegóły zegarka
                  </Typography>
                  <Grid container spacing={2}>
                    {(product?.case_diameter || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Średnica koperty
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.case_diameter > 0 ? `${product.case_diameter} mm` : 'Nie określono'}
                          </Typography>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            type="number"
                            name="case_diameter"
                            value={editedProduct?.case_diameter || ''}
                            onChange={handleNumberInputChange}
                            InputProps={{
                              endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                            }}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Grid>
                    )}
                    
                    {(product?.bracelet_type || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Typ bransolety
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {translateValue(product.bracelet_type, braceletMap)}
                          </Typography>
                        ) : (
                          <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                            <Select
                              name="bracelet_type"
                              value={editedProduct?.bracelet_type || ''}
                              onChange={handleInputChange}
                            >
                              {Object.entries(braceletMap).map(([key, value]) => (
                                <MenuItem key={key} value={key}>{value}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                    )}
                    
                    {(product?.movement || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Mechanizm
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.movement}
                          </Typography>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            name="movement"
                            value={editedProduct?.movement || ''}
                            onChange={handleInputChange}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Grid>
                    )}
                    
                    {(product?.diamonds_setting || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Diamenty
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {translateValue(product.diamonds_setting, diamondsMap)}
                          </Typography>
                        ) : (
                          <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                            <Select
                              name="diamonds_setting"
                              value={editedProduct?.diamonds_setting || ''}
                              onChange={handleInputChange}
                            >
                              {Object.entries(diamondsMap).map(([key, value]) => (
                                <MenuItem key={key} value={key}>{value}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                    )}
                    
                    {(product?.dial_color || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Kolor tarczy
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.dial_color === 'other' && product.display_dial_color
                              ? product.display_dial_color
                              : product.dial_color === 'mother_of_pearl'
                                ? 'Masa perłowa'
                                : product.dial_color === 'two_tone'
                                  ? 'Dwukolorowy'
                                  : translateValue(product.dial_color, colorMap)}
                          </Typography>
                        ) : (
                          <>
                            <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                              <Select
                                name="dial_color"
                                value={editedProduct?.dial_color || ''}
                                onChange={handleInputChange}
                              >
                                {Object.entries(colorMap).map(([key, value]) => (
                                  <MenuItem key={key} value={key}>{value}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            {editedProduct?.dial_color === 'other' && (
                              <TextField
                                fullWidth
                                size="small"
                                label="Niestandardowy kolor tarczy"
                                name="display_dial_color"
                                value={editedProduct?.display_dial_color || ''}
                                onChange={handleInputChange}
                                sx={{ mt: 1 }}
                              />
                            )}
                          </>
                        )}
                      </Grid>
                    )}
                    
                    {(product?.reference_number || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Referencja
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.reference_number}
                          </Typography>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            name="reference_number"
                            value={editedProduct?.reference_number || ''}
                            onChange={handleInputChange}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Grid>
                    )}
                    
                    {(product?.production_year || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Rok produkcji
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.production_year}
                          </Typography>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            type="number"
                            name="production_year"
                            value={editedProduct?.production_year || ''}
                            onChange={handleNumberInputChange}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Grid>
                    )}
                    
                    {(product?.condition || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Stan
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {translateValue(product.condition, conditionMap)}
                          </Typography>
                        ) : (
                          <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                            <Select
                              name="condition"
                              value={editedProduct?.condition || ''}
                              onChange={handleInputChange}
                            >
                              {Object.entries(conditionMap).map(([key, value]) => (
                                <MenuItem key={key} value={key}>{value}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                    )}
                    
                    {(product?.has_documents !== undefined || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Dokumenty
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {translateValue(product.has_documents ? 'yes' : 'no', documentsMap)}
                          </Typography>
                        ) : (
                          <FormControl size="small" sx={{ ml: 2, minWidth: 120 }}>
                            <Select
                              name="has_documents"
                              value={editedProduct?.has_documents ? true : false}
                              onChange={(e) => {
                                setEditedProduct({
                                  ...editedProduct,
                                  has_documents: e.target.value
                                });
                              }}
                            >
                              <MenuItem value={true}>Tak</MenuItem>
                              <MenuItem value={false}>Nie</MenuItem>
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                    )}
                    
                    {(product?.serial_number || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Numer seryjny
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.serial_number}
                          </Typography>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            name="serial_number"
                            value={editedProduct?.serial_number || ''}
                            onChange={handleInputChange}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Grid>
                    )}
                  </Grid>
                </Paper>
              )}
              
              {/* Szczegóły biżuterii */}
              {product.category !== 'watch' && (
                <Paper sx={{ p: 3, mb: 2 }}>
                  <Typography variant="h6" gutterBottom color="primary">
                    Szczegóły biżuterii
                  </Typography>
                  <Grid container spacing={2}>
                    {/* Podstawowe informacje */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Typ biżuterii
                      </Typography>
                      {!editMode ? (
                        <Typography variant="body1" gutterBottom>
                          {translateValue(product.jewelry_type, jewelryTypeMap)}
                        </Typography>
                      ) : (
                        <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                          <Select
                            name="jewelry_type"
                            value={editedProduct.jewelry_type || ''}
                            onChange={handleInputChange}
                          >
                            {Object.entries(jewelryTypeMap).map(([key, value]) => (
                              <MenuItem key={key} value={key}>{value}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Materiał
                      </Typography>
                      {!editMode ? (
                        <Typography variant="body1" gutterBottom>
                          {translateValue(product.material, jewelryMaterialMap)}
                        </Typography>
                      ) : (
                        <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                          <Select
                            name="material"
                            value={editedProduct.material || ''}
                            onChange={handleInputChange}
                          >
                            {Object.entries(jewelryMaterialMap).map(([key, value]) => (
                              <MenuItem key={key} value={key}>{value}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                    {product.gold_color && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Kolor złota
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          {translateValue(product.gold_color, goldColorMap)}
                        </Typography>
                      </Grid>
                    )}
                    {(product?.gold_purity || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Próba złota
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.gold_purity}
                          </Typography>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            name="gold_purity"
                            value={editedProduct?.gold_purity || ''}
                            onChange={handleInputChange}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Grid>
                    )}
                    {(product?.weight_grams || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Waga (g)
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.weight_grams}g
                          </Typography>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            type="number"
                            name="weight_grams"
                            value={editedProduct?.weight_grams || ''}
                            onChange={handleNumberInputChange}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Grid>
                    )}
                    {(product?.ring_size || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Rozmiar pierścionka
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {product.ring_size}
                          </Typography>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            name="ring_size"
                            value={editedProduct?.ring_size || ''}
                            onChange={handleInputChange}
                            sx={{ mt: 1 }}
                          />
                        )}
                      </Grid>
                    )}
                    {(product?.clasp_type || editMode) && (
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Typ zapięcia
                        </Typography>
                        {!editMode ? (
                          <Typography variant="body1" gutterBottom>
                            {translateValue(product.clasp_type, claspTypeMap)}
                          </Typography>
                        ) : (
                          <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                            <Select
                              name="clasp_type"
                              value={editedProduct?.clasp_type || ''}
                              onChange={handleInputChange}
                            >
                              {Object.entries(claspTypeMap).map(([key, value]) => (
                                <MenuItem key={key} value={key}>{value}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                    )}
                    
                    {/* Kamień centralny */}
                    {((product?.has_center_stone && product?.center_stone_type) || (editMode && editedProduct?.has_center_stone)) ? (
                      <>
                        <Grid item xs={12}>
                          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                            Kamień centralny
                          </Typography>
                          {editMode && (
                            <FormControl size="small" sx={{ ml: 2, minWidth: 120 }}>
                              <Select
                                name="has_center_stone"
                                value={editedProduct?.has_center_stone ? true : false}
                                onChange={(e) => {
                                  setEditedProduct({
                                    ...editedProduct,
                                    has_center_stone: e.target.value
                                  });
                                }}
                              >
                                <MenuItem value={true}>Tak</MenuItem>
                                <MenuItem value={false}>Nie</MenuItem>
                              </Select>
                            </FormControl>
                          )}
                        </Grid>
                        {(product?.center_stone_type || (editMode && editedProduct?.has_center_stone)) && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Typ kamienia
                            </Typography>
                            {!editMode ? (
                              <Typography variant="body1" gutterBottom>
                                {translateValue(product.center_stone_type, stoneTypeMap)}
                              </Typography>
                            ) : (
                              <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                <Select
                                  name="center_stone_type"
                                  value={editedProduct?.center_stone_type || ''}
                                  onChange={handleInputChange}
                                >
                                  {Object.entries(stoneTypeMap).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>{value}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            )}
                          </Grid>
                        )}
                        {product.center_stone_shape && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Kształt
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {translateValue(product.center_stone_shape, stoneShapeMap)}
                            </Typography>
                          </Grid>
                        )}
                        {product.center_stone_size && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Wielkość (ct)
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {product.center_stone_size}ct
                            </Typography>
                          </Grid>
                        )}
                        {product.center_stone_shape && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Kształt
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {translateValue(product.center_stone_shape, stoneShapeMap)}
                            </Typography>
                          </Grid>
                        )}
                        {product.center_stone_color && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Kolor
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {translateValue(product.center_stone_color, stoneColorMap)}
                            </Typography>
                          </Grid>
                        )}
                        {product.center_stone_clarity && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Czystość
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {translateValue(product.center_stone_clarity, stoneClarityMap)}
                            </Typography>
                          </Grid>
                        )}
                        {product.center_stone_cut && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Szlif
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {translateValue(product.center_stone_cut, stoneCutMap)}
                            </Typography>
                          </Grid>
                        )}
                        {product.center_stone_polish && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Polishing
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {translateValue(product.center_stone_polish, stonePolishMap)}
                            </Typography>
                          </Grid>
                        )}
                        {product.center_stone_symmetry && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Symmetry
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              {translateValue(product.center_stone_symmetry, stoneSymmetryMap)}
                            </Typography>
                          </Grid>
                        )}
                      </>
                    ) : null}  
                    
                    {/* Kamienie boczne */}
                    {((product?.has_side_stones && product?.side_stones_type) || (editMode && editedProduct?.has_side_stones)) ? (
                      <>
                        <Grid item xs={12}>
                          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                            Kamienie boczne
                          </Typography>
                          {editMode && (
                            <FormControl size="small" sx={{ ml: 2, minWidth: 120 }}>
                              <Select
                                name="has_side_stones"
                                value={editedProduct?.has_side_stones ? true : false}
                                onChange={(e) => {
                                  setEditedProduct({
                                    ...editedProduct,
                                    has_side_stones: e.target.value
                                  });
                                }}
                              >
                                <MenuItem value={true}>Tak</MenuItem>
                                <MenuItem value={false}>Nie</MenuItem>
                              </Select>
                            </FormControl>
                          )}
                        </Grid>
                        {(product?.side_stones_type || (editMode && editedProduct?.has_side_stones)) && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Typ kamieni
                            </Typography>
                            {!editMode ? (
                              <Typography variant="body1" gutterBottom>
                                {translateValue(product.side_stones_type, stoneTypeMap)}
                              </Typography>
                            ) : (
                              <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                <Select
                                  name="side_stones_type"
                                  value={editedProduct?.side_stones_type || ''}
                                  onChange={handleInputChange}
                                >
                                  {Object.entries(stoneTypeMap).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>{value}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            )}
                          </Grid>
                        )}
                        {(product?.side_stones_count || (editMode && editedProduct?.has_side_stones)) && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Ilość kamieni
                            </Typography>
                            {!editMode ? (
                              <Typography variant="body1" gutterBottom>
                                {product.side_stones_count}
                              </Typography>
                            ) : (
                              <TextField
                                fullWidth
                                size="small"
                                type="number"
                                name="side_stones_count"
                                value={editedProduct?.side_stones_count || ''}
                                onChange={handleNumberInputChange}
                                sx={{ mt: 1 }}
                              />
                            )}
                          </Grid>
                        )}
                        {(product?.side_stones_weight || (editMode && editedProduct?.has_side_stones)) && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Łączna waga (ct)
                            </Typography>
                            {!editMode ? (
                              <Typography variant="body1" gutterBottom>
                                {product.side_stones_weight}ct
                              </Typography>
                            ) : (
                              <TextField
                                fullWidth
                                size="small"
                                type="number"
                                name="side_stones_weight"
                                value={editedProduct?.side_stones_weight || ''}
                                onChange={handleNumberInputChange}
                                sx={{ mt: 1 }}
                              />
                            )}
                          </Grid>
                        )}
                        {((product?.side_stones_color_from && product?.side_stones_color_to) || (editMode && editedProduct?.has_side_stones)) && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Kolor (od-do)
                            </Typography>
                            {!editMode ? (
                              <Typography variant="body1" gutterBottom>
                                {product.side_stones_color_from} - {product.side_stones_color_to}
                              </Typography>
                            ) : (
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <FormControl size="small" sx={{ mt: 1, flex: 1 }}>
                                  <InputLabel>Od</InputLabel>
                                  <Select
                                    name="side_stones_color_from"
                                    value={editedProduct?.side_stones_color_from || ''}
                                    onChange={handleInputChange}
                                    label="Od"
                                  >
                                    {Object.entries(stoneColorMap).map(([key, value]) => (
                                      <MenuItem key={key} value={key}>{value}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                <FormControl size="small" sx={{ mt: 1, flex: 1 }}>
                                  <InputLabel>Do</InputLabel>
                                  <Select
                                    name="side_stones_color_to"
                                    value={editedProduct?.side_stones_color_to || ''}
                                    onChange={handleInputChange}
                                    label="Do"
                                  >
                                    {Object.entries(stoneColorMap).map(([key, value]) => (
                                      <MenuItem key={key} value={key}>{value}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Box>
                            )}
                          </Grid>
                        )}
                        {((product?.side_stones_clarity_from && product?.side_stones_clarity_to) || (editMode && editedProduct?.has_side_stones)) && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Czystość (od-do)
                            </Typography>
                            {!editMode ? (
                              <Typography variant="body1" gutterBottom>
                                {product.side_stones_clarity_from} - {product.side_stones_clarity_to}
                              </Typography>
                            ) : (
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <FormControl size="small" sx={{ mt: 1, flex: 1 }}>
                                  <InputLabel>Od</InputLabel>
                                  <Select
                                    name="side_stones_clarity_from"
                                    value={editedProduct?.side_stones_clarity_from || ''}
                                    onChange={handleInputChange}
                                    label="Od"
                                  >
                                    {Object.entries(stoneClarityMap).map(([key, value]) => (
                                      <MenuItem key={key} value={key}>{value}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                <FormControl size="small" sx={{ mt: 1, flex: 1 }}>
                                  <InputLabel>Do</InputLabel>
                                  <Select
                                    name="side_stones_clarity_to"
                                    value={editedProduct?.side_stones_clarity_to || ''}
                                    onChange={handleInputChange}
                                    label="Do"
                                  >
                                    {Object.entries(stoneClarityMap).map(([key, value]) => (
                                      <MenuItem key={key} value={key}>{value}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Box>
                            )}
                          </Grid>
                        )}
                        {(product?.side_stones_cut || (editMode && editedProduct?.has_side_stones)) && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="text.secondary">
                              Szlif
                            </Typography>
                            {!editMode ? (
                              <Typography variant="body1" gutterBottom>
                                {translateValue(product.side_stones_cut, stoneCutMap)}
                              </Typography>
                            ) : (
                              <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                <Select
                                  name="side_stones_cut"
                                  value={editedProduct?.side_stones_cut || ''}
                                  onChange={handleInputChange}
                                >
                                  {Object.entries(stoneCutMap).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>{value}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            )}
                          </Grid>
                        )}
                      </>
                    ) : null}
                  </Grid>
                </Paper>
              )}
              {/* Certyfikaty */}
              {product.certificate_numbers && Object.keys(product.certificate_numbers).length > 0 && (
                <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                  <Typography variant="h6" gutterBottom color="primary">
                    Certyfikaty
                  </Typography>
                  <Grid container spacing={2}>
                    {Object.entries(product.certificate_numbers).map(([cert, number]) => (
                      number ? (
                        <Grid item xs={12} sm={6} key={cert}>
                          <Typography variant="subtitle2" color="text.secondary">
                            {cert.toUpperCase()}
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            {number}
                          </Typography>
                        </Grid>
                      ) : null
                    ))}
                  </Grid>
                </Paper>
              )}

              {/* Opis */}
              {(product?.description || editMode) && (
                <Paper sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom color="primary">
                    Opis
                  </Typography>
                  {!editMode ? (
                    <Typography variant="body1" gutterBottom>
                      {product?.description || 'Brak opisu'}
                    </Typography>
                  ) : (
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      name="description"
                      value={editedProduct?.description || ''}
                      onChange={handleInputChange}
                      placeholder="Wpisz opis produktu"
                      sx={{ mt: 1 }}
                    />
                  )}
                </Paper>
              )}

              {/* Data dodania i aktualizacji */}
              <Paper sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom color="primary">
                  Informacje systemowe
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Data dodania
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {new Date(product.created_at).toLocaleString('pl-PL')}
                    </Typography>
                  </Grid>
                  {product.updated_at && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Data aktualizacji
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        {new Date(product.updated_at).toLocaleString('pl-PL')}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Sekcja raportów sprzedaży dla administratorów */}
      {isAdmin && (
        <Paper sx={{ p: 3, mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Raporty sprzedaży oczekujące na zatwierdzenie
          </Typography>
          
          {loadingReports ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
              <CircularProgress />
            </Box>
          ) : salesReports.length > 0 ? (
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Produkt</TableCell>
                    <TableCell>Pracownik</TableCell>
                    <TableCell>Data sprzedaży</TableCell>
                    <TableCell>Lokalizacja</TableCell>
                    <TableCell align="right">Kwota</TableCell>
                    <TableCell>Akcje</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {salesReports.map((report) => (
                    <TableRow key={report.id}>
                      <TableCell>
                        {report.product_data?.type === 'jewelry' 
                          ? `${report.product_data?.jewelry_name || ''} ${report.product_data?.category || ''}` 
                          : `${report.product_data?.brand || ''} ${report.product_data?.model || ''}`}
                      </TableCell>
                      <TableCell>{report.employeeName}</TableCell>
                      <TableCell>{format(report.transactionDate, 'dd.MM.yyyy')}</TableCell>
                      <TableCell>{report.location}</TableCell>
                      <TableCell align="right">{formatPrice(report.amount)}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Button 
                            size="small" 
                            variant="contained" 
                            color="success"
                            onClick={() => handleApproveReport(report.id)}
                          >
                            Zatwierdź
                          </Button>
                          <Button 
                            size="small" 
                            variant="outlined" 
                            color="error"
                            onClick={() => handleRejectReport(report.id)}
                          >
                            Odrzuć
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body1" color="textSecondary">
              Brak raportów sprzedaży oczekujących na zatwierdzenie.
            </Typography>
          )}
        </Paper>
      )}

        {/* Dialog ze zdjęciem */}
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          maxWidth="xl"
          fullWidth
        >
          <DialogContent sx={{ position: 'relative', p: 0 }}>
            <IconButton
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'white',
                bgcolor: 'rgba(0, 0, 0, 0.5)',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.7)',
                },
              }}
              onClick={() => setOpenDialog(false)}
            >
              <CloseIcon />
            </IconButton>
            <img
              src={product?.images?.[selectedImageIndex] ? 
                `${product.images[selectedImageIndex]}?alt=media` : 
                'https://via.placeholder.com/600x600'
              }
              alt="Powiększone zdjęcie"
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '90vh',
                objectFit: 'contain'
              }}
            />
          </DialogContent>
        </Dialog>

        {/* Dialog potwierdzenia usunięcia */}
        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
        >
          <DialogTitle>Potwierdź usunięcie</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Czy na pewno chcesz usunąć ten produkt? Tej operacji nie można cofnąć.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)}>Anuluj</Button>
            <Button onClick={handleDelete} color="error" autoFocus>
              Usuń
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog zgłaszania sprzedaży */}
        <Dialog open={openReportSaleDialog} onClose={() => setOpenReportSaleDialog(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            Zgłoś sprzedaż produktu
            <IconButton
              aria-label="close"
              onClick={() => setOpenReportSaleDialog(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              Uzupełnij dane dotyczące sprzedaży produktu
            </DialogContentText>
            
            {/* Wyszukiwarka klienta */}
            <TextField
              fullWidth
              margin="normal"
              label="Wyszukaj klienta"
              variant="outlined"
              value={clientSearchTerm}
              onChange={(e) => filterClients(e.target.value)}
              disabled={loadingClients || showNewClientForm}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            
            {/* Wybór klienta */}
            <FormControl fullWidth margin="normal" disabled={loadingClients || showNewClientForm}>
              <InputLabel id="client-select-label">Klient</InputLabel>
              <Select
                labelId="client-select-label"
                id="client-select"
                value={saleData.client_id || ''}
                label="Klient"
                required
                onOpen={() => fetchClients()} // Odśwież listę klientów przy każdym otwarciu
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  const selectedClient = clients.find(client => client.id === selectedValue);
                  console.log('Wybrano klienta:', selectedValue, selectedClient);
                  
                  // Użyj pola name jeśli istnieje, w przeciwnym razie użyj firstName i lastName
                  const clientName = selectedClient ? 
                    (selectedClient.name || `${selectedClient.firstName || ''} ${selectedClient.lastName || ''}`.trim()) : '';
                  
                  setSaleData({
                    ...saleData, 
                    client_id: selectedValue,
                    client_name: clientName
                  });
                }}
                renderValue={(selected) => {
                  if (!selected) return "Wybierz klienta";
                  const selectedClient = clients.find(client => client.id === selected);
                  if (!selectedClient) return "Wybierz klienta";
                  
                  // Użyj pola name jeśli istnieje, w przeciwnym razie użyj firstName i lastName
                  const clientName = selectedClient.name || 
                    `${selectedClient.firstName || ''} ${selectedClient.lastName || ''}`.trim();
                  
                  return `${clientName} ${selectedClient.phone ? `(${selectedClient.phone})` : ''}`;
                }}
                MenuProps={{
                  PaperProps: {
                    style: { maxHeight: 300 },
                  },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  }
                }}
              >
                <MenuItem value="">Wybierz klienta</MenuItem>
                
                {loadingClients ? (
                  <MenuItem disabled>
                    <Box display="flex" alignItems="center">
                      <CircularProgress size={20} sx={{ mr: 1 }} />
                      Ładowanie klientów...
                    </Box>
                  </MenuItem>
                ) : filteredClients.length === 0 ? (
                  <MenuItem disabled>Brak wyników wyszukiwania</MenuItem>
                ) : (
                  filteredClients.map((client) => (
                    <MenuItem 
                      key={client.id} 
                      value={client.id}
                    >
                      <Box>
                        <Typography variant="body1">
                          {client.name || `${client.firstName || ''} ${client.lastName || ''}`.trim()}
                        </Typography>
                        {client.phone && (
                          <Typography variant="body2" color="text.secondary">
                            Tel: {client.phone}
                          </Typography>
                        )}
                        {client.email && (
                          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                            {client.email}
                          </Typography>
                        )}
                      </Box>
                    </MenuItem>
                  ))
                )}
              </Select>
              <FormHelperText>
                {!showNewClientForm && (
                  <Button 
                    size="small" 
                    onClick={() => setShowNewClientForm(true)}
                    sx={{ mt: 1 }}
                  >
                    + Dodaj nowego klienta
                  </Button>
                )}
              </FormHelperText>
            </FormControl>
            
            {/* Formularz nowego klienta */}
            {showNewClientForm && (
              <Paper variant="outlined" sx={{ p: 2, mt: 2, mb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">Nowy klient</Typography>
                  <IconButton size="small" onClick={() => setShowNewClientForm(false)}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
                
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Imię"
                      value={newClientData.firstName}
                      onChange={(e) => setNewClientData({...newClientData, firstName: e.target.value})}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Nazwisko"
                      value={newClientData.lastName}
                      onChange={(e) => setNewClientData({...newClientData, lastName: e.target.value})}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      type="email"
                      value={newClientData.email}
                      onChange={(e) => setNewClientData({...newClientData, email: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Telefon"
                      value={newClientData.phone}
                      onChange={(e) => setNewClientData({...newClientData, phone: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Adres"
                      value={newClientData.address}
                      onChange={(e) => setNewClientData({...newClientData, address: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Miasto"
                      value={newClientData.city}
                      onChange={(e) => setNewClientData({...newClientData, city: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Kod pocztowy"
                      value={newClientData.postalCode}
                      onChange={(e) => setNewClientData({...newClientData, postalCode: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Notatki"
                      multiline
                      rows={2}
                      value={newClientData.notes}
                      onChange={(e) => setNewClientData({...newClientData, notes: e.target.value})}
                    />
                  </Grid>
                </Grid>
                
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleCreateClient}
                  >
                    Zapisz klienta
                  </Button>
                </Box>
              </Paper>
            )}
            
            <FormControl fullWidth margin="normal">
              <InputLabel>Miejsce sprzedaży</InputLabel>
              <Select
                value={saleData.location}
                onChange={(e) => setSaleData({...saleData, location: e.target.value})}
                label="Miejsce sprzedaży"
                required
              >
                {Object.keys(locationMap).map((locationKey) => (
                  <MenuItem key={locationKey} value={locationKey}>
                    {locationMap[locationKey]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <FormControl component="fieldset" margin="normal">
              <FormLabel component="legend">Firma</FormLabel>
              <RadioGroup
                row
                value={saleData.company}
                onChange={(e) => setSaleData({...saleData, company: e.target.value})}
              >
                <FormControlLabel value="MM_GOLD" control={<Radio />} label="M&M GOLD" />
                <FormControlLabel value="VVS" control={<Radio />} label="VVS" />
              </RadioGroup>
            </FormControl>
            
            <FormControl fullWidth margin="normal">
              <InputLabel>Sposób płatności</InputLabel>
              <Select
                value={saleData.payment_method}
                onChange={(e) => setSaleData({...saleData, payment_method: e.target.value})}
                label="Sposób płatności"
                required
              >
                <MenuItem value="cash">Gotówka</MenuItem>
                <MenuItem value="card">Karta płatnicza</MenuItem>
                <MenuItem value="transfer">Przelew bankowy</MenuItem>
                <MenuItem value="other">Inny</MenuItem>
              </Select>
            </FormControl>
            
            <TextField
              fullWidth
              label="Data sprzedaży"
              type="date"
              value={saleData.sale_date}
              onChange={(e) => setSaleData({...saleData, sale_date: e.target.value})}
              margin="normal"
              InputLabelProps={{ shrink: true }}
            />
            
            <TextField
              fullWidth
              label="Kwota sprzedaży"
              type="number"
              value={saleData.amount}
              onChange={(e) => setSaleData({...saleData, amount: e.target.value})}
              margin="normal"
              InputProps={{
                startAdornment: <InputAdornment position="start">PLN</InputAdornment>,
                inputProps: { min: 0, step: "0.01" }
              }}
              required
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenReportSaleDialog(false)} color="inherit">
              Anuluj
            </Button>
            <Button 
              onClick={handleReportSale} 
              variant="contained" 
              color="success" 
              disabled={!saleData.location || !saleData.client_id || showNewClientForm}
            >
              Zgłoś sprzedaż
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar do powiadomień */}
        <Snackbar 
          open={snackbar.open} 
          autoHideDuration={6000} 
          onClose={() => setSnackbar(prev => ({...prev, open: false}))}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            onClose={() => setSnackbar(prev => ({...prev, open: false}))}
            severity={snackbar.severity}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    );
  };

  export default ProductDetails;